// Module
var code = "<script id=\"wcc-components-attachment-controls-select\" type=\"text/template\">\r\n    <span class=\"far fa-check\"></span>\r\n</script>";
// Exports
module.exports = code;